<div>
    <div class="dx-card wide-card">
        <h4 class="content-block ap-green">Suspect Map</h4>
        <div class="content-block">
            <form #form="ngForm" (ngSubmit)="viewReport()" autocomplete="off" showValidationSummary="true">
                <dx-validation-group>
                    <dx-responsive-box singleColumnScreen="xs sm md">
                        <dxi-row [ratio]="1"></dxi-row>
                        <dxi-row [ratio]="1"></dxi-row>
                        <dxi-row [ratio]="1"></dxi-row>
                        <dxi-col [ratio]=".3"></dxi-col>
                        <dxi-col [ratio]=".7"></dxi-col>
                        <dxi-col [ratio]=".3"></dxi-col>
                        <dxi-col [ratio]=".4"></dxi-col>
                        <dxi-col [ratio]=".5"></dxi-col>
                        <dxi-col [ratio]=".5"></dxi-col>
                        <dxi-item>
                            <dxi-location [row]="0" [col]="0"></dxi-location>
                            <div class="dx-field-label rightalign"> Country </div>
                        </dxi-item>
                        <dxi-item>
                            <dxi-location [row]="0" [col]="1"></dxi-location>
                            <div class="dx-field">
                                <div class="maxwidth">
                                    <dx-drop-down-box class="maxwidth" #countryDropDown [(value)]="countryValue"
                                        placeholder="Select a value..." [showClearButton]="true"
                                        [dataSource]="countryData" valueExpr="countryID" displayExpr="countryName"
                                        (onValueChanged)="onCountryDropDownBoxValueChanged($event)">
                                        <div *dxTemplate="let data of 'content'">
                                            <dx-list #countrylist [dataSource]="countryData" [height]="300"
                                                [selectionMode]="'all'" [selectAllMode]="'allPages'"
                                                [showSelectionControls]="true" [searchEnabled]="true"
                                                searchExpr="countryName" searchMode="contains" keyExpr="countryID"
                                                displayExpr="countryName" [selectedItemKeys]="countryValue"
                                                (onSelectionChanged)="oncountryListSelectionChanged($event)"
                                                scrollingEnabled="true">
                                            </dx-list>
                                        </div>
                                        <dx-validator>
                                            <dxi-validation-rule type="required"
                                                message="Please select atleast one country.">
                                            </dxi-validation-rule>
                                        </dx-validator>
                                    </dx-drop-down-box>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxi-location [row]="0" [col]="2" [colspan]="4"></dxi-location>
                            <div class="dx-field leftmargin">
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxi-location [row]="1" [col]="0"></dxi-location>
                            <div class="dx-field-label rightalign"> LBU-Plant-Country </div>
                        </dxi-item>
                        <dxi-item>
                            <dxi-location [row]="1" [col]="1"></dxi-location>
                            <div class="dx-field">
                                <div class="maxwidth">
                                    <dx-drop-down-box [disabled]="disableallfilters" class="maxwidth" #plantsDropDown
                                        [(value)]="plantValue" placeholder="Select a value..." [showClearButton]="true"
                                        [dataSource]="plantData" valueExpr="siteID" displayExpr="siteCombined"
                                        (onValueChanged)="onPlantsDropDownBoxValueChanged($event)">
                                        <div *dxTemplate="let data of 'content'">
                                            <dx-list #plantslist [dataSource]="plantData" [height]="300"
                                                [selectionMode]="'all'" [selectAllMode]="'allPages'"
                                                [showSelectionControls]="true" [searchEnabled]="true"
                                                searchExpr="siteCombined" searchMode="contains" keyExpr="siteID"
                                                displayExpr="siteCombined"
                                                (onSelectionChanged)="onplantListSelectionChanged($event)"
                                                scrollingEnabled="true">
                                            </dx-list>
                                        </div>
                                        <dx-validator>
                                            <dxi-validation-rule type="required"
                                                message="Please select atleast one plant.">
                                            </dxi-validation-rule>
                                        </dx-validator>
                                    </dx-drop-down-box>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxi-location [row]="1" [col]="4"></dxi-location>
                            <div class="dx-field-label"> Miles from plant(s) (1000 max) </div>
                        </dxi-item>
                        <dxi-item>
                            <dxi-location [row]="1" [col]="5"></dxi-location>
                            <div class="dx-field">
                                <div>
                                    <dx-text-box [disabled]="disableallfilters" [(value)]="miles">
                                        <dx-validator>
                                            <dxi-validation-rule type="required"
                                                message="Please enter miles from plants.">
                                            </dxi-validation-rule>
                                            <dxi-validation-rule type="pattern" [pattern]="numberPattern"
                                                message="Only numbers are allowed.">
                                            </dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxi-location [row]="1" [col]="2"></dxi-location>
                            <div class="dx-field-label rightalign"> Can Cross Borders </div>
                        </dxi-item>
                        <dxi-item>
                            <dxi-location [row]="1" [col]="3"></dxi-location>
                            <div class="dx-field">
                                <div class="maxwidth">
                                    <div>
                                        <dx-radio-group [disabled]="disableallfilters" [items]="radiobtndata"
                                            valueExpr="value" displayExpr="text" [(value)]="cancrossborders"
                                            layout="horizontal"></dx-radio-group>
                                    </div>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxi-location [row]="2" [col]="0"></dxi-location>
                            <div class="dx-field-label rightalign"> Industry Segments </div>
                        </dxi-item>
                        <dxi-item>
                            <dxi-location [row]="2" [col]="1"></dxi-location>
                            <div class="dx-field">
                                <div class="maxwidth">
                                    <dx-drop-down-box [disabled]="disableallfilters" class="maxwidth" #segmentDropDown
                                        [(value)]="segmentValue" placeholder="Select a value..."
                                        [showClearButton]="true" [dataSource]="segmentData"
                                        valueExpr="globalIndustrySegmentId" displayExpr="name"
                                        (onValueChanged)="onSegmentsDropDownBoxValueChanged($event)">
                                        <div *dxTemplate="let data of 'content'">
                                            <dx-list #segmentlist [dataSource]="segmentData" [height]="300"
                                                [selectionMode]="'all'" [selectAllMode]="'allPages'"
                                                [showSelectionControls]="true" [searchEnabled]="true" searchExpr="name"
                                                searchMode="contains" keyExpr="globalIndustrySegmentId"
                                                displayExpr="name"
                                                (onSelectionChanged)="onSegmentListSelectionChanged($event)"
                                                scrollingEnabled="true">
                                            </dx-list>
                                        </div>
                                        <dx-validator>
                                            <dxi-validation-rule type="required"
                                                message="Please select atleast one industry segment.">
                                            </dxi-validation-rule>
                                        </dx-validator>
                                    </dx-drop-down-box>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxi-location [row]="2" [col]="2"></dxi-location>
                            <div class="dx-field-label rightalign"> Show Rings </div>
                        </dxi-item>
                        <dxi-item>
                            <dxi-location [row]="2" [col]="3"></dxi-location>
                            <div class="dx-field">
                                <div class="maxwidth">
                                    <div>
                                        <dx-radio-group [disabled]="disableallfilters" [items]="radiobtndata"
                                            valueExpr="value" displayExpr="text" [(value)]="showRings"
                                            layout="horizontal"></dx-radio-group>
                                    </div>
                                </div>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxi-location [row]="2" [col]="4" [colspan]="2"></dxi-location>
                            <div class="dx-field leftmargin">
                                <dx-button [disabled]="disableallfilters" class="ap-blue-btn" [useSubmitBehavior]="true"
                                    text="View Reports">
                                </dx-button>
                            </div>
                        </dxi-item>
                        <div>
                            <dx-validation-summary></dx-validation-summary>
                        </div>
                    </dx-responsive-box>
                </dx-validation-group>
            </form>
            <hr />
        </div>
        <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
            [shading]="false" [closeOnOutsideClick]="false">
        </dx-load-panel>
        <div>
            <h5 *ngIf="showGrid" class="leftmargin">SAP Customers within {{miles}} of {{planttitle}}</h5>
            <h5 *ngIf="showGrid" class="leftmargin">Black Dots are competitor CO2 Plants.</h5>
            <p *ngIf="showGrid" class="red smallheader">AIR PRODUCTS CONFIDENTIAL - INTERNAL USE ONLY</p>
            <table style="width: 100%;">
                <tr>
                    <td>
                        <div class="content-block">
                            <div id="map" style="float: left;margin-right: 15px;"></div>
                        </div>
                        <div class="legends">
                            <div id="industrySegmentLegend">
                                <div style="text-align: center"><b>Industry Segment</b></div>
                                <hr />
                            </div>
                            <div id="productLegend">
                                <div style="text-align: center"><b>Prod</b></div>
                                <hr />
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div *ngIf="showGrid">
                            <dx-data-grid id="gridContainer" class="gridmargin gridwidth topmargin"
                                [dataSource]="dataSource" [allowColumnReordering]="true" [showRowLines]="true"
                                [showColumnLines]="true" [showBorders]="true" [columnAutoWidth]="true"
                                [rowAlternationEnabled]="true" [columnHidingEnabled]="false"
                                [allowColumnResizing]="false">
                                <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
                                <dxo-export [enabled]="true"></dxo-export>
                                <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
                                <dxo-toolbar>
                                    <dxi-item location="before" class="leftmargin">
                                        <h4>Sales for the last 12 months</h4>
                                    </dxi-item>
                                    <dxi-item location="after">
                                        <dx-button icon="exportxlsx" class="ap-blue-btn" (onClick)="exportExcel($event)"
                                            text="Export to Excel">
                                        </dx-button>
                                    </dxi-item>
                                    <dxi-item name="searchPanel"></dxi-item>
                                </dxo-toolbar>
                                <dxi-column dataField="globalIndustrySegment"
                                    caption="Global Industry Segment"></dxi-column>
                                <dxi-column dataField="globalIndustrySegmentCount" caption="Count"></dxi-column>
                                <dxi-column dataField="totalMTD" caption="CO2(MTD)"></dxi-column>
                                <dxo-summary>
                                    <dxi-total-item [alignByColumn]="true" [customizeText]="getTextTotal"
                                        column="globalIndustrySegment" summaryType="sum"> </dxi-total-item>
                                    <dxi-total-item [alignByColumn]="true" [customizeText]="getCountValueOnly"
                                        column="globalIndustrySegmentCount" summaryType="sum"> </dxi-total-item>
                                    <dxi-total-item [alignByColumn]="true" [customizeText]="getValueToOneDecimal"
                                        column="totalMTD" summaryType="sum"> </dxi-total-item>
                                </dxo-summary>
                            </dx-data-grid>
                        </div>
                    </td>
                </tr>
            </table>


        </div>


    </div>
</div>